module.exports = __webpack_public_path__ + "assets/images/EURO.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EURO.png
// module id = 1371
// module chunks = 1